<div class="ride-group" *ngIf="dSS.dienststelle && dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <h3>RadimDienst-Schutzleistungen</h3>
    </ion-col>
  </ion-row>
</div>
<ng-container *ngIf="dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Inspektionspaket"
            interface="popover"
            [disabled]="!!(dSS.dienststelle.disabledInspektion && dSS.dienststelle.inspektion)"
            [(ngModel)]="dSS.dienststelle.inspektion"
            (ionChange)="update($event); checkInspektion();"
            >
            <ion-select-option
              *ngFor="let option of getInspectionOption()"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row class="pt-2">
    <ion-col class="py-0">
      <ion-list class="py-0">
        <ion-item lines="inset">
          <ion-select
            label="RadFahrSchutz"
            interface="popover"
            [(ngModel)]="dSS.radFahrSchutz"
            [disabled]="dSS.dienststelle.disabledRadFahrSchutz"
            (ionChange)="update($event)"

          >
          <ion-select-option
          *ngFor="let option of JaNeinList"
          [value]="option.value"
        >
          {{ option.display }}
        </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-icon
          class="info_icon_select__position"
          name="information-circle-outline"
          (click)="dSS.showDiv('Z')"
        >
        </ion-icon>
      </ion-list>
      <div *ngIf="dSS.currInfo === 'Z'">
        <p class="RIDE-info">
          Damit Ihr Dienstrad jederzeit weltweit geschützt ist, ist ein
          RadFahrSchutz obligatorischer Bestandteil des Dienstrad-Leasings. Er
          beinhaltet u.a. eine Vollkaskoversicherung, eine europaweite
          Mobilitätsgarantie und einen Ratenschutz.
        </p>
      </div>
    </ion-col>
  </ion-row>
</ng-container>
